<template>
 <div>
    <section class=" container section is-main-section">
      <form @submit.prevent="save">
        <div>
            <v-card-component title="Edit Vehicle Details" icon="mdi-bus">
               <v-card-actions>
        <router-link :to="{ name: 'vehicleDetails' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions>
<v-row>
<v-col>
      <v-row>
        <v-col cols="12" lg="3" sm="6" >
        <span class="body-2 font-weight-medium"> Academic Year</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete required v-model="academicYearID" key="id" class="my-0 py-1" single-line placeholder="---Select---" :items="academicYears" item-text="academicYear" item-value="id">
        </v-autocomplete>
      </v-col>
      <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium">Select Franchisee</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete v-model="franchiseeID" key="id" class="my-0 py-1" required  single-line placeholder="---Select---" :items="franchiseeArr" item-text="companyName" item-value="id">
        </v-autocomplete>
      </v-col>
      <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Vehicle Registration Number <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="registrationNo" required class="my-0 py-1">
        </v-text-field>
      </v-col>
       <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Make Of the vehicle <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="MakeOfvehicle" required class="my-0 py-1">
        </v-text-field>
      </v-col>
    </v-row>
     <v-row>
        <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Model Of the vehicle </span>
        <v-text-field v-model.trim="ModelOfvehicle" class="my-0 py-1">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Vehicle Chasis No </span>
        <v-text-field v-model.trim="ChasisNo"  class="my-0 py-1">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Battery No </span>
        <v-text-field v-model.trim="batteryNo" class="my-0 py-1">
        </v-text-field>
      </v-col>
       <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Seating Capacity <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="seatingCapacity" required class="my-0 py-1" type="number">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Vehicle Engine Number</span>
        <v-text-field v-model.trim="engineNumber" class="my-0 py-1" type="text">
        </v-text-field>
      </v-col>
          <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> VTS Activation</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete required v-model="vtsActivation" key="id" class="my-0 py-1" single-line placeholder="---Select---" readonly :items="vtsactivations" item-text="name" item-value="id">
        </v-autocomplete>
      </v-col>
     <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Vehicle Type</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete required v-model="vehicleType" @change="clear()" key="id" class="my-0 py-1" single-line placeholder="---Select---" :items="VehicleTypes" item-text="name" item-value="value">
        </v-autocomplete>
      </v-col>
       <v-col cols="12" lg="3" sm="6" v-if="this.vehicleType !=='School Owned'">
        <span class="body-2 font-weight-medium"> Monthly Rent Cost</span>
        <span class="error--text ml-1">*</span>
         <v-text-field v-model.trim="rentCost" :required='isRequired' class="my-0 py-1" type="number">
        </v-text-field>
      </v-col>
    </v-row>
     <v-row>
      <v-col cols="12" lg="3" md="6">
              <label class="body-2 font-weight-medium"> Purchase Date</label>
              <custom-date-picker v-model="Purchasedate" />
            </v-col>
          <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> RC Book No.</span>
        <span class="error--text ml-1">*</span>
         <v-text-field v-model.trim="RCBookNo" required class="my-0 py-1" type="text">
        </v-text-field>
      </v-col>
     <v-col cols="12" lg="3" md="6">
              <label class="body-2 font-weight-medium"> RC Start Date <span class="error--text">*</span></label>
              <custom-date-picker v-model="RCStartdate" required />
            </v-col>
      <v-col cols="12" lg="3" md="6">
              <label class="body-2 font-weight-medium"> RC Expiry Date <span class="error--text">*</span></label>
              <custom-date-picker v-model="RCExpirydate" :minToDate="this.RCStartdate" required />
            </v-col>
    </v-row>
</v-col>
</v-row>
<div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label">
                  Upload Vehicle Details
                </label>
                <b-field class="file is-primary">
                  <b-upload @input="onFilechange()" v-model="dropFile" multiple class="file-label">
                    <span class="file-cta">
                      <b-icon class="file-icon" icon="upload"></b-icon>
                      <span class="file-label">Click to upload</span>
                    </span>
                  </b-upload>
                </b-field>
                <span class="has-text-danger">Allowed files:  .png, .jpg, .jpeg, .pdf </span>
<br/><br/> <span class="has-text-danger">File's that are not supported will be removed automatically!</span>
                <span v-if="dropFile.length > 0">
                  <div class="tags" v-for="(file, i) in dropFile" :key="i">
                    <span class="tag is-primary">
                      {{ file.name }}
                    </span>
                    <button class="delete is-small" type="button" @click="deleteDropFile(i)"></button>
                  </div>
                </span>
              </div>
            </div>
            <button class="button is-success" :disabled="hasClicked" type="submit" style="margin-top:20px;margin-right:100px;">Save</button>
          </div>
           <span v-if="dropFile1.length > 0">
        <span style="margin-top:50px;" class="has-text-primary">Already Uploaded Documents</span>
                    <div  class="tags" v-for="(file, i) in dropFile1" :key="i">
                     <div @click="download(file.urlPath)" class="tag is-primary">
                        {{ file.name }}
                      </div>

                      <button class="delete is-small" type="button"
                        @click="deleteDropFile1(file.id)"></button>
                    </div>
                  </span>
  </v-card-component>
        </div>
        <div></div>
      </form>
    </section>
  </div>
</template>
<script>
import CustomDatePicker from '@/components/template/CustomDatePicker'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import moment from 'moment'
import Utils from '@/utils'
export default {
  name: 'editVehicleDetails',
  props: ['vehicleID'],
  components: {
    VCardComponent,
    CustomDatePicker
  },
  data () {
    return {
      total: 0,
      dropFile: [],
      franchiseeID: '',
      vtsActivation: null,
      batteryNo: '',
      MakeOfvehicle: '',
      RCBookNo: '',
      RCExpirydate: '',
      RCStartdate: '',
      ChasisNo: '',
      engineNumber: '',
      rentCost: '',
      MakeOfthevehicle: '',
      seatingCapacity: '',
      Purchasedate: '',
      ModelOfvehicle: '',
      registrationNo: '',
      franchiseeArr: [],
      academicYearID: '',
      isRequired: false,
      vehicleType: '',
      selectedFranchisee: [],
      vehicleData: [],
      academicYears: [],
      vehicleDocumentData: [],
      dropFile1: [],
      title: '',
      hasClicked: false,
      deleteFileIdArr: [],
      loader: true,
      isWrite: false,
      vtsactivations: [
        { id: 1, name: 'YES' }
      ],
      VehicleTypes: [
        { id: 1, name: 'School Owned', value: 'School Owned' },
        { id: 2, name: 'Leased Vehicle', value: 'Leased Vehicle' },
        { id: 3, name: 'Vendor Owned', value: 'Vendor Owned' }
      ],
      allowedFiles: [
        'png', 'jpg', 'jpeg', 'pdf'
      ]
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getFranchiseeList()
    await this.getYear()
    await this.vehicleDetails()
    await this.vehicleDetailsDocuments()
  },
  methods: {
    vehicleDetails: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehicledetails/${this.vehicleID}`)
        this.vehicleData = data
        console.log('this.vehicleData', this.vehicleData)
        this.franchiseeID = this.vehicleData.franchiseeID
        this.academicYearID = this.vehicleData.academicYearID
        this.registrationNo = this.vehicleData.vehicleRegistrationNumber
        this.MakeOfvehicle = this.vehicleData.makeOfVehicle
        this.ModelOfvehicle = this.vehicleData.modelOfVehicle
        this.ChasisNo = this.vehicleData.chasisNumber
        this.batteryNo = this.vehicleData.batteryNumber
        this.seatingCapacity = this.vehicleData.seatingCapacity
        this.vehicleType = this.vehicleData.vehicleType
        this.engineNumber = this.vehicleData.vehicleEngineNumber
        this.RCBookNo = this.vehicleData.rcBookNumber
        this.RCStartdate = moment(this.vehicleData.rcStartDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        this.RCExpirydate = moment(this.vehicleData.rcExpiryDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        this.rentCost = this.vehicleData.monthlyRentCost
        if (this.vehicleData.vehiclePurchaseDate !== null) {
          this.Purchasedate = moment(this.vehicleData.vehiclePurchaseDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        }
        if (this.vehicleData.vtsActivation === false) {
          this.vtsActivation = 0
        } else {
          this.vtsActivation = 1
        }
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    vehicleDetailsDocuments: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehicledetails/${this.vehicleID}`)
        this.vehicleDocumentData = data
        this.dropFile1 = this.vehicleDocumentData.vehicleDocumentsMaps
        if (this.dropFile1) {
          this.dropFile1.forEach(docID => {
            docID.name = docID.urlKey.substring(docID.urlKey.lastIndexOf('/') + 1)
          })
        }
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getYear: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=true`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    deleteDropFile (i) {
      this.dropFile.splice(i, 1)
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee`)
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    save: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        if (this.vehicleType !== 'School Owned' && Number(this.rentCost) < 1) {
          this.loadingComponent.close()
          return this.$buefy.dialog.alert({
            message: 'Please Enter Valid Amount',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        if (this.deleteFileIdArr.length > 0) {
          this.deleteFileIdArr.forEach(docID => {
            this.deleteDocument(docID)
          })
        }
        let formData = new FormData()
        formData.append('vehicleRegistrationNumber', this.registrationNo)
        formData.append('makeOfVehicle', this.MakeOfvehicle)
        formData.append('modelOfVehicle', this.ModelOfvehicle)
        formData.append('chasisNumber', this.ChasisNo)
        formData.append('batteryNumber', this.batteryNo)
        formData.append('seatingCapacity', this.seatingCapacity)
        formData.append('vtsActivation', this.vtsActivation)
        formData.append('vehicleType', this.vehicleType)
        formData.append('vehicleEngineNumber', this.engineNumber)
        formData.append('rcBookNumber', this.RCBookNo)
        formData.append('rcStartDate', this.RCStartdate)
        formData.append('rcExpiryDate', this.RCExpirydate)
        if (this.vehiclePurchaseDate !== '') {
          formData.append('vehiclePurchaseDate', this.Purchasedate)
        } else {
          formData.append('vehiclePurchaseDate', '')
        }
        if (this.vehicleType !== 'School Owned') {
          formData.append('monthlyRentCost', this.rentCost)
        } else {
          formData.append('monthlyRentCost', '')
        }
        for (let i = 0; i < this.dropFile.length; i++) {
          formData.append('vehicleDetailsAttachements', this.dropFile[i])
        }
        // for (var pair of formData.entries()) {
        //   console.log(pair)
        // }
        this.hasClicked = true

        await http.put(`${constants.API_URL}/api/transport/vehicledetails/vehicledetails/${this.vehicleID}`, formData)
        this.loader = false
        this.loadingComponent.close()
        this.$router.push({ name: 'vehicleDetails' })
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    download: async function (i) {
      try {
        let url = await http.get(`${constants.API_URL}/api/staff/downloadurl?s3urlKey=${i}`)
        window.open(url.data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    deleteDropFile1 (docID) {
      this.$buefy.dialog.confirm({
        title: 'Deleting Image',
        message: '"Do you want to Delete this file"?',
        confirmText: 'Delete Image',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.dropFile1.forEach(element => {
            if (docID === element.id) {
              var index = this.dropFile1.indexOf(element)
              if (index !== -1) {
                this.dropFile1.splice(index, 1)
              }
              this.deleteFileIdArr.push(docID)
            }
          })
        }
      })
    },
    deleteDocument: async function (deldocID) {
      try {
        await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehicledetails/status/${deldocID}`)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    onFilechange () {
      let r = this.dropFile.filter((a, i) => {
        if (this.allowedFiles.includes(a.name.split('.').pop())) {
        }
        return this.allowedFiles.includes(a.name.split('.').pop())
      })
      this.dropFile = r
      if (this.dropFile.length > 2) {
        this.dropFile = []
        return this.$buefy.dialog.alert({
          message: 'Maximum 2 Attachements Are allowed',
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    clear () {
      if (this.vehicleType !== 'School Owned') {
        this.isRequired = true
      }
    }

  }
}
</script>
